const STORAGE_KEY = "home-dashboard-ui";

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isHomeRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/home" || path.startsWith("/home/");
};

export const loadHomePersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveHomePersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist home dashboard state", error);
  }
};

export const clearHomePersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

const readCount = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

export const getPersistedHomeUiState = () => {
  const data = loadHomePersistence();
  if (!data) {
    return {
      hasCache: false,
      apiCount: 0,
      engineCount: 0,
      usageCount: 0,
      tokenBalance: 0
    };
  }

  const apiCount = readCount(data.apiCount);
  const engineCount = readCount(data.engineCount);
  const usageCount = readCount(data.usageCount);
  const tokenBalance = readCount(data.tokenBalance);

  return {
    hasCache: Boolean(apiCount || engineCount || usageCount || tokenBalance),
    apiCount,
    engineCount,
    usageCount,
    tokenBalance
  };
};
